import React, { useState } from 'react'
import CustomTable from '../../../CustomTable'
import { Typography, Statistic } from 'antd'
import useAxios from 'axios-hooks'
import { CardListStyle, CardStyle } from '../style'
import currency from 'currency.js';

const PaydayDetailTable = ({ invoice_group_id, resign }) => {

  const [currentPage, setCurrentPage] = useState(1)
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState('')
  const [pageSize, setPageSize] = useState(20)
  const [{ data, loading, error }, refetch] = useAxios(
    {
      url: `/admins/api/invoice_groups/${invoice_group_id}/payday_details?per_page=${pageSize}&page=${currentPage}&search=${search}&resign=${resign}&sort=${sort ?? ''}`,
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },

    },
    {
      useCache: false,
    }
  )

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => <a>{index + 1}</a>,
    },
    {
      title: 'เลขบัตรประชาชน',
      dataIndex: 'citizen_id',
      key: 'citizen_id',
      sorter: true,
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'เลขที่สัญญา',
      key: 'loanId',
      sorter: true,
      render: (text, _) => <a>{_.raw_data.loanId}</a>,
    },
    {
      title: 'ชื่อ',
      dataIndex: 'firstname',
      key: 'firstname',
      sorter: true,
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'นามสกุล',
      dataIndex: 'lastname',
      key: 'lastname',
      sorter: true,
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'สินเชื่อ',
      key: 'productName',
      sorter: true,
      render: (text, _) => <a>{_.raw_data.productName}</a>,
    },
    {
      title: 'จำนวนเงินถอน',
      key: 'cashOut',
      sorter: true,
      render: (text, _) => <a>{currency(_.raw_data.cashOut).format({
        symbol: '',
        separator: ',',
        precision: 2
      })}</a>,
    },
    {
      title: 'ค่าธรรมเนียมเบิกถอน',
      key: 'withdrawalFeeIncVat',
      sorter: true,
      render: (text, _) => <a>{currency(_.raw_data.withdrawalFeeIncVat).format({
        symbol: '',
        separator: ',',
        precision: 2
      })}</a>,
    },
    {
      title: 'ค่าธรรมเนียมธนาคาร',
      key: 'bankFee',
      sorter: true,
      render: (text, _) => <a>{currency(_.raw_data.bankFee).format({
        symbol: '',
        separator: ',',
        precision: 2
      })}</a>,
    },

  ]

  return <>
    <CardListStyle>
      <CardStyle>
        <Statistic title="รวมจำนวนเงินถอน" value={data ? data.total_cash_out : 0} precision={2} />
      </CardStyle>
      <CardStyle>
        <Statistic title="รวมค่าธรรมเนียมเบิกถอน" value={data ? data.total_withdrawal_fee_inc_vat : 0}
          precision={2} />
      </CardStyle>
      <CardStyle>
        <Statistic title="รวมค่าธรรมเนียมธนาคาร" value={data ? data.total_bank_fee : 0} precision={2} />
      </CardStyle>
    </CardListStyle>
    <CustomTable
      pageSize={pageSize}
      setPageSize={setPageSize}
      searchPlaceholder={'ค้นหาโดย ชื่อ นามสกุล เลขบัตรประชาชน เลขที่สัญญา'} loading={loading}
      columns={columns} data={data ? data.invoice_payday_details.map(obj => ({ ...obj, key: obj.id })) : []} total={data ? data.total_pages : 0}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearch={setSearch}
      setSort={setSort}
    />
  </>
}

export default PaydayDetailTable
